import { Shadow, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React, { useContext, useMemo } from 'react';

import { FinancialDetailsContext } from '../../context';
import { transformProduct } from '../../utils';
import { EmptyList } from '../EmptyList';
import { ErrorListing } from '../ErrorListing';
import { AssetCard } from '../shared/AssetCard';
import { AssetLoadingCard } from '../shared/AssetLoadingCard';
import { ProductDistributionHeader } from '../shared/ProductDistributionHeader';

import { emptyListProps } from './constants';

export const Liquidity: React.FC = () => {
  const { data, loading, error, refresher } = useContext(FinancialDetailsContext);
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const products = useMemo(() => (data?.liquidity || []).map(transformProduct), [data]);

  const renderTable = () => {
    if (error) {
      return <ErrorListing handleReload={refresher} />;
    }

    if (loading) {
      return Array.from({ length: 5 }).map((_, index) => (
        <AssetLoadingCard key={index} index={index} />
      ));
    }

    if (!data?.liquidity?.length) {
      return <EmptyList {...emptyListProps} />;
    }

    return (
      <VStack space="stack.nano">
        {products.map((product) => {
          return (
            <AssetCard
              key={product.marketNameNormalized}
              product={product}
              openDetailsBelow={isDesktop}
            />
          );
        })}
      </VStack>
    );
  };

  return (
    <Shadow level={1} borderRadius="sm" my="inset.sm" paddingX="inline.xxxs" paddingY="inline.xxs">
      <VStack space="stack.xxs">
        <ProductDistributionHeader
          isLoading={loading}
          totalValue={data?.total.totalInvested || 0}
          products={products}
          hasError={!!error}
        />
        {renderTable()}
      </VStack>
    </Shadow>
  );
};
